export const convertCamelCaseToKebabCase = (str: string | undefined): string | undefined => {
    if (!str) {
        return undefined;
    }
    // Insert a dash when a lowercase letter or digit is followed by an uppercase letter,
    // then convert the whole string to lowercase.
    return str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
};
